
import { Placeholder_forKind, textLinesFor, sizePresets, LabelPrintItem, maxTextLines, LabelInventoryKind } from "../../../Shared/Label.js";
import { exists, cons, tryFind, sortBy, truncate, isEmpty, empty as empty_1, ofSeq, singleton as singleton_1, append as append_1, indexed, filter, map, length, mapIndexed, ofArray } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { FormState__getValidation, LabelCodePosition, LabelCodeType, LabelConfiguration, LabelTextLine, LabelFontSize } from "../../../Shared/Shared.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, comparePrimitives, createObj } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TextValue } from "../../../Components/Text.js";
import { Button, TextButton } from "../../../Components/Button.js";
import Recycle_Bin_1 from "../../../../public/assets/icons/Recycle_Bin_1.svg";
import { PlaceholderInput } from "../../../Components/PlaceholderInput.js";
import { SegmentedControl } from "../../../Components/SegmentedControl.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { SWR_getTools } from "../../../Requests/Tool.js";
import { SWR_getConsumables } from "../../../Requests/Consumable.js";
import { unwrap, bind, map as map_1, defaultArg } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { nonSeeded } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Random.js";
import { SearchableSelect } from "../../../Components/Select.js";
import { Msg } from "./Types.js";
import { defaultOf } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { toLocalTime, toString } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { Dimension, DimensionInput } from "../../../Components/DimensionInput.js";
import { Input } from "../../../Components/Input.js";
import { TabsMenu } from "../../../Widgets/TabsMenu.js";
import { InformationAlert, ErrorAlert } from "../../../Components/Alert.js";
import { LabelPreview } from "../../../Components/LabelPreview.js";
import { update as update_1, init as init_1, previewCode, previewLines } from "./State.js";
import Printer from "../../../../public/assets/icons/Printer.svg";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";

const kinds = ofArray([new LabelInventoryKind(0, []), new LabelInventoryKind(1, []), new LabelInventoryKind(2, []), new LabelInventoryKind(3, [])]);

function kindKey(kind) {
    switch (kind.tag) {
        case 1:
            return "set";
        case 2:
            return "tool_with_quantity";
        case 3:
            return "consumable";
        default:
            return "tool";
    }
}

function kindLabel(t, kind) {
    return t(concat("labels.kind.", ...kindKey(kind)));
}

const previewSampleSize = 10;

function TextLineEditor(props) {
    let elems_5;
    const t = useTranslation()[0];
    const updateLine = (index, line) => {
        props.OnChange(mapIndexed((i, existing) => {
            if (i === index) {
                return line;
            }
            else {
                return existing;
            }
        }, props.Lines));
    };
    const fontSizeOptions = ofArray([{
        Label: t("labels.settings.font_auto"),
        TestId: "label-font-auto",
        Value: new LabelFontSize(3, []),
    }, {
        Label: t("labels.settings.font_small"),
        TestId: "label-font-small",
        Value: new LabelFontSize(0, []),
    }, {
        Label: t("labels.settings.font_medium"),
        TestId: "label-font-medium",
        Value: new LabelFontSize(1, []),
    }, {
        Label: t("labels.settings.font_large"),
        TestId: "label-font-large",
        Value: new LabelFontSize(2, []),
    }]);
    return reactElement("div", createObj(ofArray([["data-test-id", concat("label-text-lines-", ...kindKey(props.Kind))], ["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_5 = toList(delay(() => append(mapIndexed((index_1, line_1) => {
        let elems_3, elems, elems_2, elems_1;
        return reactElement("div", createObj(ofArray([["key", index_1], ["className", join(" ", ["flex", "flex-col", "gap-3", "rounded-xl", "border", "border-border", "bg-white", "p-4"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-between"])], (elems = toList(delay(() => append(singleton(createElement(TextValue, {
            FontWeight: "bold",
            TestId: "",
            Text: `${t("labels.settings.text_line")} ${index_1 + 1}`,
        })), delay(() => {
            let Label_4;
            return (length(props.Lines) > 1) ? singleton(createElement(TextButton, (Label_4 = t("general.remove"), {
                ComponentState: props.ComponentState,
                Icon: Recycle_Bin_1(),
                Label: Label_4,
                OnClick: () => {
                    props.OnChange(map((tuple) => tuple[1], filter((tupledArg) => (tupledArg[0] !== index_1), indexed(props.Lines))));
                },
                TestId: `label-text-line-${index_1}-delete`,
                Variant: "muted",
            }))) : empty();
        })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PlaceholderInput, {
            ComponentState: props.ComponentState,
            OnChange: (content) => {
                updateLine(index_1, new LabelTextLine(content, line_1.FontSize, line_1.Bold));
            },
            Placeholders: props.Placeholders,
            TestId: `label-text-line-${index_1}`,
            Value: line_1.Content,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "items-end", "gap-4"])], (elems_2 = [createElement(SegmentedControl, {
            ComponentState: props.ComponentState,
            Label: t("labels.settings.font_size"),
            OnChange: (fontSize) => {
                updateLine(index_1, new LabelTextLine(line_1.Content, fontSize, line_1.Bold));
            },
            Options: map((option) => ({
                Label: option.Label,
                TestId: `label-text-line-${index_1}-${option.TestId}`,
                Value: option.Value,
            }), fontSizeOptions),
            TestId: `label-text-line-${index_1}-font-size`,
            Value: line_1.FontSize,
        }), reactElement("div", createObj(ofArray([["className", join(" ", ["pb-1.5"])], (elems_1 = [Checkbox({
            ComponentState: props.ComponentState,
            IsChecked: line_1.Bold,
            Label: t("labels.settings.bold"),
            OnCheck: (bold) => {
                updateLine(index_1, new LabelTextLine(line_1.Content, line_1.FontSize, bold));
            },
            TestId: `label-text-line-${index_1}-bold`,
        })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
    }, props.Lines), delay(() => {
        let elems_4;
        return (length(props.Lines) < maxTextLines) ? singleton(reactElement("div", createObj(singleton_1((elems_4 = [createElement(TextButton, {
            ComponentState: props.ComponentState,
            Label: t("labels.settings.add_text_line"),
            OnClick: () => {
                props.OnChange(append_1(props.Lines, singleton_1(new LabelTextLine("", new LabelFontSize(3, []), false))));
            },
            TestId: "label-add-text-line",
            Variant: "blueButton",
        })], ["children", reactApi.Children.toArray(Array.from(elems_4))]))))) : empty();
    })))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

function InventoryPreviewPicker(props) {
    let selectedOption, elems;
    const patternInput = useTranslation();
    const tools = SWR_getTools();
    const consumables = SWR_getConsumables();
    const loadedTools = defaultArg(map_1(ofSeq, tools.data), empty_1());
    let allOptions;
    const matchValue = props.Kind;
    if (matchValue.tag === 3) {
        allOptions = map((consumable) => ({
            label: consumable.Name,
            value: new LabelPrintItem(new LabelInventoryKind(3, []), consumable.StringId, undefined, undefined),
        }), defaultArg(map_1(ofSeq, consumables.data), empty_1()));
    }
    else {
        const kind = matchValue;
        const overviewType = (kind.tag === 1) ? "set" : ((kind.tag === 2) ? "toolWithQuantity" : "tool");
        allOptions = map((tool_1) => ({
            label: (tool_1.DisplayName.trim() !== "") ? tool_1.DisplayName : concat(tool_1.Manufacturer, " ", ...tool_1.Model).trim(),
            value: new LabelPrintItem(kind, tool_1.Id, undefined, undefined),
        }), filter((tool) => (tool.ToolOverviewType === overviewType), loadedTools));
    }
    let selectedEntityId;
    const matchValue_1 = props.State.PreviewSource;
    selectedEntityId = ((matchValue_1.tag === 0) ? undefined : matchValue_1.fields[0].EntityId);
    const isLoaded = !isEmpty(allOptions);
    const patternInput_1 = reactApi.useState("");
    let sample;
    const dependencies_1 = [props.Kind, isLoaded];
    sample = reactApi.useMemo(() => {
        const random = nonSeeded();
        return truncate(previewSampleSize, sortBy((_arg) => (random.Next0() | 0), filter((option_4) => (option_4.label.trim() !== ""), allOptions), {
            Compare: (x, y) => (comparePrimitives(x, y) | 0),
        }));
    }, dependencies_1);
    let matching;
    const needle = patternInput_1[0].trim().toLowerCase();
    matching = ((needle === "") ? sample : truncate(previewSampleSize, filter((option_5) => (option_5.label.toLowerCase().indexOf(needle) >= 0), allOptions)));
    let options;
    const matchValue_2 = bind((id) => tryFind((option_6) => (option_6.value.EntityId === id), allOptions), selectedEntityId);
    let matchResult, selectedOption_1;
    if (matchValue_2 != null) {
        if ((selectedOption = matchValue_2, !exists((option_8) => (option_8.value.EntityId === selectedOption.value.EntityId), matching))) {
            matchResult = 0;
            selectedOption_1 = matchValue_2;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            options = cons(selectedOption_1, matching);
            break;
        }
        default:
            options = matching;
    }
    const selected = bind((id_1) => tryFind((option_9) => (option_9.value.EntityId === id_1), options), selectedEntityId);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems = [createElement(SearchableSelect, {
        ComponentState: props.ComponentState,
        IsClearable: true,
        Label: patternInput[0]("labels.settings.preview_with_inventory"),
        NoOptionsMessage: "select.no_options",
        OnChange: (selection) => {
            if (selection == null) {
                props.Dispatch(new Msg(12, []));
            }
            else {
                props.Dispatch(new Msg(10, [selection.value]));
            }
        },
        OnInputChange: patternInput_1[1],
        Options: options,
        PlaceholderKey: "labels.settings.preview_search_placeholder",
        TestId: "label-preview-inventory-select",
        Value: unwrap(selected),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ReservedCodes(props) {
    let elems_2, elems_1;
    const t = useTranslation()[0];
    const matchValue = props.State.ReservedCodes;
    if (matchValue.tag === 0) {
        return defaultOf();
    }
    else if (isEmpty(matchValue.fields[0])) {
        return defaultOf();
    }
    else {
        return reactElement("div", createObj(ofArray([["data-test-id", "label-reserved-codes"], ["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_2 = [createElement(TextValue, {
            FontWeight: "bold",
            TestId: "",
            Text: t("labels.settings.reserved_codes"),
        }), reactElement("p", {
            className: join(" ", ["text-sm", "text-text-muted"]),
            children: t("labels.settings.reserved_codes_info"),
        }), reactElement("ul", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "divide-y", "divide-border", "rounded-xl", "border", "border-border"])], (elems_1 = toList(delay(() => map((reserved) => {
            let elems, Label;
            return reactElement("li", createObj(ofArray([["key", reserved.Code], ["data-test-id", concat("label-reserved-code-", ...reserved.Code)], ["className", join(" ", ["flex", "items-center", "justify-between", "px-3", "py-1.5", "text-sm"])], (elems = [reactElement("span", {
                className: join(" ", ["font-mono"]),
                children: reserved.Code,
            }), reactElement("span", {
                className: join(" ", ["text-text-muted"]),
                children: toString(toLocalTime(reserved.CreatedAt), "dd.MM.yyyy"),
            }), createElement(TextButton, (Label = t("general.remove"), {
                ComponentState: props.ComponentState,
                Icon: Recycle_Bin_1(),
                Label: Label,
                OnClick: () => {
                    props.Dispatch(new Msg(16, [reserved.Code]));
                },
                TestId: concat("label-reserved-code-", reserved.Code, ..."-delete"),
                Variant: "default",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }, matchValue.fields[0]))), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
    }
}

function LabelEditor(props) {
    let elems_10, elems_6, elems_9;
    const t = useTranslation()[0];
    const draft = props.Draft;
    const state = props.State;
    const componentState = state.FormState.IsLoading ? "disabled" : "enabled";
    const setDraft = (updated) => {
        props.Dispatch(new Msg(3, [updated]));
    };
    return reactElement("div", createObj(ofArray([["data-test-id", "label-settings-editor"], ["className", join(" ", ["grid", "grid-cols-1", "xl:grid-cols-[minmax(0,1fr),minmax(20rem,28rem)]", "gap-8"])], (elems_10 = [reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-6"])], (elems_6 = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: t("labels.settings.print_settings"),
    })), delay(() => append(singleton(createElement(DimensionInput, {
        ComponentState: componentState,
        OnChange: (dimension) => {
            setDraft(new LabelConfiguration(dimension.WidthMm, dimension.HeightMm, dimension.MarginMm, draft.CodeType, draft.CodePosition, draft.ShowCodeValue, draft.ShowLogo, draft.CodePrefix, draft.TextLines, draft.Enabled));
        },
        Presets: sizePresets,
        TestId: "label-dimension",
        Value: new Dimension(draft.WidthMm, draft.HeightMm, draft.MarginMm),
    })), delay(() => {
        let elems;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-6"])], (elems = [createElement(SegmentedControl, {
            ComponentState: componentState,
            Label: t("labels.settings.code_type"),
            OnChange: (codeType) => {
                setDraft(new LabelConfiguration(draft.WidthMm, draft.HeightMm, draft.MarginMm, codeType, draft.CodePosition, draft.ShowCodeValue, draft.ShowLogo, draft.CodePrefix, draft.TextLines, draft.Enabled));
            },
            Options: ofArray([{
                Label: t("labels.settings.code_qr"),
                TestId: "label-code-type-qr",
                Value: new LabelCodeType(0, []),
            }, {
                Label: t("labels.settings.code_barcode"),
                TestId: "label-code-type-barcode",
                Value: new LabelCodeType(1, []),
            }]),
            TestId: "label-code-type",
            Value: draft.CodeType,
        }), createElement(SegmentedControl, {
            ComponentState: componentState,
            Label: t("labels.settings.code_position"),
            OnChange: (position) => {
                setDraft(new LabelConfiguration(draft.WidthMm, draft.HeightMm, draft.MarginMm, draft.CodeType, position, draft.ShowCodeValue, draft.ShowLogo, draft.CodePrefix, draft.TextLines, draft.Enabled));
            },
            Options: ofArray([{
                Label: t("labels.settings.position_left"),
                TestId: "label-code-position-left",
                Value: new LabelCodePosition(0, []),
            }, {
                Label: t("labels.settings.position_right"),
                TestId: "label-code-position-right",
                Value: new LabelCodePosition(1, []),
            }, {
                Label: t("labels.settings.position_top"),
                TestId: "label-code-position-top",
                Value: new LabelCodePosition(2, []),
            }, {
                Label: t("labels.settings.position_code_only"),
                TestId: "label-code-position-code-only",
                Value: new LabelCodePosition(3, []),
            }]),
            TestId: "label-code-position",
            Value: draft.CodePosition,
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let elems_2, elems_1;
            return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-wrap", "gap-6", "items-end"])], (elems_2 = [Checkbox({
                ComponentState: componentState,
                IsChecked: draft.ShowCodeValue,
                Label: t("labels.settings.show_code_value"),
                OnCheck: (value_7) => {
                    setDraft(new LabelConfiguration(draft.WidthMm, draft.HeightMm, draft.MarginMm, draft.CodeType, draft.CodePosition, value_7, draft.ShowLogo, draft.CodePrefix, draft.TextLines, draft.Enabled));
                },
                TestId: "label-show-code-value",
            }), Checkbox({
                ComponentState: (props.CustomerConfiguration.AppLogoConfiguration.WideLogoUrl != null) ? componentState : "disabled",
                IsChecked: draft.ShowLogo,
                Label: t("labels.settings.show_logo"),
                OnCheck: (value_8) => {
                    setDraft(new LabelConfiguration(draft.WidthMm, draft.HeightMm, draft.MarginMm, draft.CodeType, draft.CodePosition, draft.ShowCodeValue, value_8, draft.CodePrefix, draft.TextLines, draft.Enabled));
                },
                TestId: "label-show-logo",
            }), reactElement("div", createObj(ofArray([["className", join(" ", ["w-40"])], (elems_1 = [createElement(Input, {
                ComponentState: componentState,
                Label: t("labels.settings.code_prefix"),
                OnChange: (value_10) => {
                    setDraft(new LabelConfiguration(draft.WidthMm, draft.HeightMm, draft.MarginMm, draft.CodeType, draft.CodePosition, draft.ShowCodeValue, draft.ShowLogo, value_10, draft.TextLines, draft.Enabled));
                },
                TestId: "label-code-prefix",
                Value: draft.CodePrefix,
            })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => append(singleton(reactElement("p", {
                className: join(" ", ["text-sm", "text-text-muted"]),
                children: t("labels.settings.code_prefix_info"),
            })), delay(() => {
                let elems_4, elems_3;
                return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-3"])], (elems_4 = [createElement(TextValue, {
                    FontWeight: "bold",
                    TestId: "labels-text-per-kind-heading",
                    Text: t("labels.settings.text_per_kind"),
                }), reactElement("div", createObj(ofArray([["data-test-id", "label-kind-tabs"], ["className", join(" ", ["flex", "gap-4"])], (elems_3 = [createElement(TabsMenu, {
                    Tabs: map((kind) => {
                        const Label_11 = kindLabel(t, kind);
                        return {
                            IsSelected: equals(state.ActiveKind, kind),
                            Label: Label_11,
                            OnClick: () => {
                                props.Dispatch(new Msg(4, [kind]));
                            },
                            TestId: concat("label-kind-tab-", ...kindKey(kind)),
                        };
                    }, kinds),
                })], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement(TextLineEditor, {
                    ComponentState: componentState,
                    Kind: state.ActiveKind,
                    Lines: textLinesFor(state.ActiveKind, draft.TextLines),
                    OnChange: (lines) => {
                        props.Dispatch(new Msg(5, [state.ActiveKind, lines]));
                    },
                    Placeholders: map((key_17) => ({
                        Key: key_17,
                        Label: t(concat("labels.placeholder.", ...key_17)),
                    }), Placeholder_forKind(state.ActiveKind)),
                }), reactElement("p", {
                    className: join(" ", ["text-sm", "text-text-muted"]),
                    children: t("labels.settings.custom_property_hint"),
                })], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                    let matchValue;
                    return append((matchValue = FormState__getValidation(state.FormState, t, "global"), (matchValue == null) ? (empty()) : singleton(createElement(ErrorAlert, {
                        Label: matchValue,
                    }))), delay(() => {
                        let elems_5;
                        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end", "gap-4"])], (elems_5 = toList(delay(() => append(state.IsDirty ? singleton(createElement(TextButton, {
                            ComponentState: componentState,
                            Label: t("general.cancel"),
                            OnClick: () => {
                                props.Dispatch(new Msg(2, []));
                            },
                            TestId: "label-settings-discard",
                            Variant: "blueButton",
                        })) : empty(), delay(() => singleton(createElement(Button, {
                            ComponentState: componentState,
                            Label: t("general.save"),
                            OnClick: () => {
                                props.Dispatch(new Msg(6, []));
                            },
                            TestId: "label-settings-save",
                            Variant: "primary",
                        })))))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => singleton(createElement(ReservedCodes, {
                            ComponentState: componentState,
                            Dispatch: props.Dispatch,
                            State: state,
                        }))));
                    }));
                }));
            }))));
        }));
    })))))), ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4", "xl:sticky", "xl:top-4", "self-start"])], (elems_9 = toList(delay(() => append(singleton(createElement(TextValue, {
        FontWeight: "bold",
        TestId: "",
        Text: concat(t("labels.settings.preview"), " · ", ...kindLabel(t, state.ActiveKind)),
    })), delay(() => {
        let elems_7, Lines_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center", "overflow-auto", "rounded-xl", "bg-background", "p-6"])], (elems_7 = [createElement(LabelPreview, (Lines_1 = previewLines(state, draft), {
            Code: previewCode(state),
            Configuration: draft,
            Lines: Lines_1,
            LogoUrl: unwrap(draft.ShowLogo ? props.CustomerConfiguration.AppLogoConfiguration.WideLogoUrl : undefined),
            TestId: "label-settings-preview",
            Zoom: 2,
        }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => append(singleton(reactElement("p", {
            className: join(" ", ["text-xs", "text-text-muted"]),
            children: t("labels.settings.preview_info"),
        })), delay(() => append(singleton(createElement(InventoryPreviewPicker, {
            ComponentState: componentState,
            Dispatch: props.Dispatch,
            Kind: state.ActiveKind,
            State: state,
        })), delay(() => {
            let elems_8, Label_14;
            return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_8 = [createElement(Button, (Label_14 = t("labels.settings.test_print"), {
                ComponentState: componentState,
                Icon: Printer(),
                Label: Label_14,
                OnClick: () => {
                    props.Dispatch(new Msg(13, []));
                },
                TestId: "label-settings-test-print",
                Variant: "secondary",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))));
        }))))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_9))])])))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

export function LabelSettings(props) {
    let elems_2, elems;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(init_1, (msg, state) => update_1(props.OnConfigurationChanged, msg, state), (_arg, _arg_1) => {
    }), undefined, undefined);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const matchValue = state_1.CustomerConfiguration;
    if (matchValue.tag === 1) {
        const configuration = matchValue.fields[0];
        const matchValue_1 = state_1.Draft;
        if (matchValue_1 != null) {
            const draft = matchValue_1;
            return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-4"])], (elems_2 = toList(delay(() => {
                let matchValue_2, stored, elems_1;
                return append((matchValue_2 = configuration.LabelConfiguration, (matchValue_2 != null) ? ((stored = matchValue_2, singleton(reactElement("div", createObj(ofArray([["data-test-id", "label-settings-status"], ["className", join(" ", ["flex", "flex-wrap", "items-center", "justify-between", "gap-4", "rounded-xl", "border", "border-border", "bg-white", "px-4", "py-3"])], (elems_1 = [reactElement("span", {
                    className: join(" ", ["text-sm"]),
                    children: stored.Enabled ? t("labels.settings.enabled_info") : t("labels.settings.disabled_info"),
                }), createElement(TextButton, {
                    ComponentState: state_1.FormState.IsLoading ? "disabled" : "enabled",
                    Label: stored.Enabled ? t("labels.settings.deactivate") : t("labels.settings.activate"),
                    OnClick: () => {
                        dispatch(new Msg(8, [!stored.Enabled]));
                    },
                    TestId: "label-settings-toggle-enabled",
                    Variant: stored.Enabled ? "redButton" : "blueButton",
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))))) : singleton(createElement(InformationAlert, {
                    Label: t("labels.settings.unsaved_template_info"),
                }))), delay(() => singleton(createElement(LabelEditor, {
                    CustomerConfiguration: configuration,
                    Dispatch: dispatch,
                    Draft: draft,
                    State: state_1,
                }))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        }
        else {
            return reactElement("div", createObj(ofArray([["data-test-id", "label-settings-empty"], ["className", join(" ", ["flex", "flex-col", "gap-4", "items-start"])], (elems = [reactElement("p", {
                className: join(" ", ["text-sm"]),
                children: t("labels.settings.empty_info"),
            }), createElement(Button, {
                ComponentState: "enabled",
                Label: t("labels.settings.create_template"),
                OnClick: () => {
                    dispatch(new Msg(1, []));
                },
                TestId: "label-settings-create",
                Variant: "primary",
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])));
        }
    }
    else {
        return defaultOf();
    }
}

